import { useStore } from 'effector-react';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { Photo } from 'model/domain';
import { sendEvent } from 'model/helpers/events.model';
import { uploadedPhotoMeta$, uploadPhotoFx } from 'model/flows/verification.model';
import { screenHistoryPush, ScreenName } from 'model/helpers/screens-history';
import { useLocalization } from 'model/localization.model';
import { Fragment, h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { version } from '../../../../../package.json';

import { Button } from 'ui/atoms/button';
import { InfoIcon } from 'ui/icons/info-icon';
import { OnboardLayout } from 'features/verify/ui/onboard-layout';
import { InputCapture } from 'ui/input/input-capture';

export const DocumentBack = () => {
	const t = useLocalization();
	const [start] = useState(Date.now());
	const meta = useStore(uploadedPhotoMeta$);

	useEffect(() => {
		screenHistoryPush(ScreenName.doc_back_instructions);
		setTimeout(() => {
			sendEvent({ event: 'doc_back_instructions_screen_shown' });
		}, 20);
	}, []);
	const handleUpload = async (photo: Photo) => {
		const t0 = performance.now();
		await uploadPhotoFx({ photo });
		const upload_time = Math.round(t0 - performance.now());
		sendEvent({
			event: 'doc_back_upload_success',
			event_attributes: { upload_time },
		});
	};
	const handleContinue = () => {
		sendEvent({
			event: 'doc_back_instructions_screen_continue',
			event_attributes: {
				duration: Date.now() - start,
			},
		});
	};
	const doc_type = t(`doc.type.${meta?.document_title?.replace(/ /g, '_')}`);

	return (
		<OnboardLayout
			title={t('mobile.doc.back.title')}
			subtitle={t('mobile.doc.back.subtitle', { doc_type })}
			info={[{
				icon: <InfoIcon/>,
				text: <Fragment>
					{t('mobile.doc.back.instructions', { doc_type })}
				</Fragment>,
			}]}
		>
			<ImageContainer>
				<img src={`https://cdn.hive.id/verify-js/${version}/images/doc_back.svg`} alt=""/>
			</ImageContainer>
			<InputCapture
				className={fluidClass}
				cameraType={'back'}
				onCapture={handleUpload}
			>
				<Button
					className={fluidClass}
					onClick={handleContinue}
					name={'mobile.doc.back.btn'}
				>
					{t('mobile.doc.back.btn')}
				</Button>
			</InputCapture>
		</OnboardLayout>
	);
};

const fluidClass = css`
  width: 100%;
`;
const ImageContainer = styled('div')`
  margin: 4px auto auto;

  @media (max-height: 500px) {
    display: none;
  }
`;
